import { NOT_FOUND, FOUND } from '../actions/types';

const initialState = {
  notfound: false,
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case NOT_FOUND:
      return {
        ...state,
        notfound: true,
      };

    case FOUND:
      return {
        ...state,
        notfound: false,
      };

    default:
      return state;
  }
}

export default reducer;
